import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import {
  saveProjectAndAssignCandidateSuccess,
  deleteProjectSuccess,
  loadProjects,
  loadProjectsSuccess,
  updateProjectSuccess,
  assignProjectSelectedId,
  setIsLikedTabActive,
  loadBarChartDataSuccess,
  resetBarChartData,
} from './projects.actions';
import { ProjectPool } from '../../shared/models/project-pool';
import { BarChartData } from '@app/shared/models/bar-chart';

export interface ProjectsState extends EntityState<ProjectPool> {
  loading: boolean;
  projectSelectedId: number;
  isLikedTabActive: boolean;
  barChartData: BarChartData | null;
}

export const projectsAdapter: EntityAdapter<ProjectPool> = createEntityAdapter<ProjectPool>({
  selectId: (project: ProjectPool) => project.talentPool.id,
  sortComparer: false,
});

export const initialState: ProjectsState = projectsAdapter.getInitialState({
  loading: false,
  projectSelectedId: 0,
  isLikedTabActive: false,
  barChartData: null,
});

export const projectsReducer = createReducer(
  initialState,
  on(loadProjects, (state) => projectsAdapter.removeAll({ ...state, loading: true })),
  on(loadProjectsSuccess, (state, projects) =>
    projectsAdapter.setAll(projects.payload.projects, { ...state, loading: false }),
  ),
  on(updateProjectSuccess, (state, { payload }) =>
    projectsAdapter.upsertOne(payload.project, state),
  ),
  on(deleteProjectSuccess, (state, { payload }) =>
    projectsAdapter.removeOne(payload.projectId, state),
  ),
  on(saveProjectAndAssignCandidateSuccess, (state, { payload }) =>
    projectsAdapter.addOne(payload.project, { ...state }),
  ),
  on(assignProjectSelectedId, (state, { payload }) => ({
    ...state,
    projectSelectedId: payload.id,
  })),
  on(setIsLikedTabActive, (state, { payload }) => ({
    ...state,
    isLikedTabActive: payload.isLikedTabActive,
  })),
  on(loadBarChartDataSuccess, (state, { data }) => ({
    ...state,
    barChartData: data,
  })),
  on(resetBarChartData, (state) => ({
    ...state,
    barChartData: null,
  })),
);
